export default "__VITE_ASSET__D6qBFIZu__ 600w";